import { ListOrganizationInvoiceRepository } from '@domain/organization-invoice/repositories/organization-invoice.repository';
import { OrganizationInvoiceRepositoryService } from '../repositories/organization-invoice.service';

export const OrganizationInvoiceProvider = [
  {
    provide: ListOrganizationInvoiceRepository,
    useClass: OrganizationInvoiceRepositoryService,
  },
];
